import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20digital%20landscape%20with%20warm%20gradient%20tones%20of%20amber%20and%20terracotta%2C%20soft%20flowing%20geometric%20shapes%2C%20modern%20artistic%20background%2C%20clean%20smooth%20textures%2C%20ethereal%20atmospheric%20light%2C%20no%20text%2C%20no%20people%2C%20peaceful%20composition&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt="P站视频指南 - 背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20 text-center">
        <div className="max-w-3xl mx-auto">
          <h1
            className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            P站视频完整指南
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 md:mb-10 leading-relaxed max-w-2xl mx-auto">
            汇集P站视频的搜索技巧、分类导航、下载方式及热门内容推荐，帮助用户快速找到高质量视频资源，轻松掌握平台核心功能与使用体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/search-tips"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              搜索技巧
            </Link>
            <Link
              to="/category/hot-recommend"
              className="w-full sm:w-auto px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-lg font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap border border-white/20"
            >
              热门推荐
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}